import { useEffect } from "react";
import { ToggleButton, DecimalInput } from "components";
import { LabelledInput, LabelledSelect } from "../../../../Fields";
import { useInput } from "hooks";

export const IncentiveEntirePurchaseSavingsTextBuilder = ({
  value = "",
  onChange = () => { },
}) => {
  const isUpTo = useInput(false);
  const saveStart = useInput("");
  const saveEnd = useInput("");
  const saveType = useInput("$");
  const offType = useInput("");
  const purchaseVal = useInput("");
  const purchaseType = useInput("Unit");
  const suffix = useInput("");
  const typeData = [
    { label: "$", value: "$" },
    { label: "%", value: "%" },
  ];
  const typeData2 = [
    { label: "$", value: "$" },
    { label: "Unit", value: "Unit" },
  ];
  const typeData3 = [
    { label: "entire purchase", value: "Entire Purchase" },
    { label: "any one item", value: "Any one item" },
  ];
  const withPurchaseRegex = /(w\/purchase\/\s*)+/g; // /(w\/purchase\/\s*)+/g
  const withPurchaseUnitRegex = /(w\/purchase\/\s*\.\d*\s*)+/g; // /(w\/purchase\/\s*)+/g

  const formatSaveValue = (ss, se, st) => {
    if (!ss) return "";
    return st === "$"
      ? `$${ss}${se ? `-$${se}` : ""}`
      : `${ss}${st}${se ? `-${se}${st}` : ""}`;
  };

  const handleUpdateValue = (ut, ss, se, st, ot, pv, pt, suf) => {
    const withPurchaseStr = `${pv ? `w/purchase/${pt === "$" ? `${pt}${pv}` : pv}` : ''}`
    let str = [
      `Save${ut ? " Up To" : ""}`,
      formatSaveValue(ss, se, st),
      `off${ot ? ` ${ot}` : ""}`,
      withPurchaseStr,
      suf?.trim(),
    ].filter(Boolean).join(" ");
    if (purchaseVal.value)
      str = pt === "$" ? str : str.replace(withPurchaseUnitRegex, withPurchaseStr);
    else
      str = str.replace(withPurchaseRegex, 'w/purchase/');
    onChange(str);
  };

  useEffect(() => {
    if (value.toLowerCase().startsWith("save")) {
      let main = value.slice(4).trimStart();
      if (purchaseVal.value)
        main = main.replace(withPurchaseRegex, 'w/purchase/');
      // else
      // main = main.replace(withPurchaseRegex, 'w/purchase/');
      // main = main.replace(withPurchaseRegex, 'w/purchase/');

      if (main.startsWith("Up To")) {
        isUpTo.setValue(true);
        main = main.slice(5).trimStart();
      } else {
        isUpTo.setValue(false);
      }
      const offIndex = main.indexOf("off");
      if (offIndex >= 0) {
        const st = main.slice(0, offIndex).trim();
        if (st.startsWith("$")) {
          saveType.setValue("$");
          const parts = st.split("-");
          saveStart.setValue(parts[0].replace("$", "").trim());
          saveEnd.setValue(parts[1] ? parts[1].replace("$", "").trim() : "");
        } else if (st.endsWith("%")) {
          saveType.setValue("%");
          const parts = st.split("-");
          saveStart.setValue(parts[0].replace("%", "").trim());
          saveEnd.setValue(parts[1] ? parts[1].replace("%", "").trim() : "");
        }
        main = main.slice(offIndex + 3).trimStart();
      }
      const purchaseIndex = main.indexOf("w/purchase/");
      if (purchaseIndex >= 0) {
        offType.setValue(main.slice(0, purchaseIndex).trim());
        main = main.slice(purchaseIndex + 11);
        const sufIndex = main.indexOf(" ");
        let vt = "";
        if (sufIndex >= 0) {
          vt = main.slice(0, sufIndex);
          // suffix.setValue(main.slice(sufIndex + 1));
        } else {
          vt = main;
          // suffix.setValue("");
        }
        if (vt.startsWith("$")) {
          purchaseType.setValue("$");
          purchaseVal.setValue(vt.slice(1).trim());
        } else {
          purchaseType.setValue("Unit");
          purchaseVal.setValue(vt.trim());
        }
      } else {
        if (main.startsWith("entire purchase")) {
          offType.setValue("Entire Purchase");
          main = main.slice(16);
        } else if (main.startsWith("any one item")) {
          offType.setValue("Any one item");
          main = main.slice(13);
        }
        // suffix.setValue(main);
      }
      value = value.replace(withPurchaseRegex, 'w/purchase/');
    }
    return () => { };
  }, [value]);

  return (
    <>
      <div className="p-2 d-flex justify-content-between align-items-center">
        <div className="mt-3">Save</div>
        <ToggleButton className="mt-3 mx-2" style={{ width: '30%' }}
          label="Up To" value={isUpTo.value}
          onChange={(e) => {
            isUpTo.setValue(e);
            handleUpdateValue(e, saveStart.value, saveEnd.value, saveType.value, offType.value, purchaseVal.value, purchaseType.value, suffix.value);
          }}
        />

        {saveType.value === "$" ? (
          <DecimalInput labeled label="Start Value" placeholder="Value" style={{ width: '96%' }}
            value={saveStart.value}
            onChange={(e) => {
              saveStart.setValue(e);
              handleUpdateValue(isUpTo.value, e, saveEnd.value, saveType.value, offType.value, purchaseVal.value, purchaseType.value, suffix.value);
            }}
          />
        ) : (
          <LabelledInput label="Start Value" placeholder="Value" style={{ width: '96%' }}
            allowclear="true" inputType="float" value={saveStart.value}
            onChange={(e) => {
              saveStart.setValue(e);
              handleUpdateValue(isUpTo.value, e, saveEnd.value, saveType.value, offType.value, purchaseVal.value, purchaseType.value, suffix.value);
            }}
          />
        )}

        <div className="mt-3 mx-1">-</div>

        {saveType.value === "$" ? (
          <DecimalInput labeled label="End Value" placeholder="Value" style={{ width: '96%' }}
            value={saveEnd.value}
            onChange={(e) => {
              saveEnd.setValue(e);
              handleUpdateValue(isUpTo.value, saveStart.value, e, saveType.value, offType.value, purchaseVal.value, purchaseType.value, suffix.value);
            }}
          />
        ) : (
          <LabelledInput label="End Value" placeholder="Value" style={{ width: '96%' }}
            allowclear="true" inputType="float" value={saveEnd.value}
            onChange={(e) => {
              saveEnd.setValue(e);
              handleUpdateValue(isUpTo.value, saveStart.value, e, saveType.value, offType.value, purchaseVal.value, purchaseType.value, suffix.value);
            }}
          />
        )}

        <LabelledSelect label="Type" style={{ width: '94%' }} className="ml-2"
          options={typeData} value={saveType.value}
          onChange={(e) => {
            saveType.setValue(e);
            handleUpdateValue(isUpTo.value, saveStart.value, saveEnd.value, e, offType.value, purchaseVal.value, purchaseType.value, suffix.value);
          }} />
      </div>
      <div className="p-2 d-flex justify-content-between align-items-center">
        <div className="mt-1">off</div>

        <LabelledSelect label="" style={{ width: '90%' }} className="ml-4"
          options={typeData3} value={offType.value}
          onChange={(e) => {
            offType.setValue(e);
            handleUpdateValue(isUpTo.value, saveStart.value, saveEnd.value, saveType.value, e, purchaseVal.value, purchaseType.value, suffix.value);
          }} />
      </div>
      <div className="p-2 d-flex justify-content-between align-items-center">
        <div className="mt-3">w/purchase</div>

        {purchaseType.value === "$" ? (
          <DecimalInput labeled label="Value" placeholder="Value" style={{ width: '96%' }}
            value={purchaseVal.value} className="ml-2"
            onChange={(e) => {
              purchaseVal.setValue(e);
              handleUpdateValue(isUpTo.value, saveStart.value, saveEnd.value, saveType.value, offType.value, e, purchaseType.value, suffix.value);
            }}
          />
        ) : (
          <LabelledInput label="Value" placeholder="Value" style={{ width: '96%' }}
            allowclear="true" inputType="float" value={purchaseVal.value} className="ml-2"
            onChange={(e) => {
              purchaseVal.setValue(e);
              handleUpdateValue(isUpTo.value, saveStart.value, saveEnd.value, saveType.value, offType.value, e, purchaseType.value, suffix.value);
            }}
          />
        )}

        <LabelledSelect label="Type" style={{ width: '96%' }} className="ml-2"
          options={typeData2} value={purchaseType.value}
          onChange={(e) => {
            purchaseType.setValue(e);
            handleUpdateValue(isUpTo.value, saveStart.value, saveEnd.value, saveType.value, offType.value, purchaseVal.value, e, suffix.value);
          }} />

        <LabelledInput label="Suffix" placeholder="Suffix" className="ml-2"
          allowclear="true" value={suffix.value}
          onChange={(e) => {
            suffix.setValue(e);
            handleUpdateValue(isUpTo.value, saveStart.value, saveEnd.value, saveType.value, offType.value, purchaseVal.value, purchaseType.value, e);
          }}
        />
      </div>
    </>
  );
};